import { Col } from 'react-bootstrap';

const ContainerCol = Col;

export default ContainerCol;
